import { slotsWithDefault } from "../utils/slots";
export const useSlots = ({ baseSlots, slots, }) => slotsWithDefault(baseSlots, slots);
export const SlotsProvider = ({ baseSlots, slots, children, }) => children(useSlots({ baseSlots, slots }));
//# sourceMappingURL=SlotsProvider.js.map